import { Component, Input } from '@angular/core';
import {
    SigmaMinusOne,
    SigmaMinusThree,
    SigmaMinusTwo,
    SigmaOne,
    SigmaThree,
    SigmaTwo,
    SigmaZero
} from '../../constants-types';

@Component({
    selector: 'sigma-lines',
    template: `
        @if (!hidden) {
            <div class="sigma-lines">
                @for (sigma of sigmas; track sigma; let i = $index) {
                    <div class="sigma-container">
                        <div
                            class="ticks"
                            [ngStyle]="{
                                opacity: i === 3 ? 0 : 1
                            }"
                        ></div>
                        @if (showDescription) {
                            <div class="sigmas">
                                {{ sigma.value }}
                            </div>
                        }
                    </div>
                }
            </div>
        }
    `,
    styleUrls: ['./sigma-lines.component.less'],
    standalone: false
})
export class SigmaLinesComponent {
    sigmas = [
        {
            value: SigmaMinusThree
        },
        {
            value: SigmaMinusTwo
        },
        {
            value: SigmaMinusOne
        },
        {
            value: SigmaZero
        },
        {
            value: SigmaOne
        },
        {
            value: SigmaTwo
        },
        {
            value: SigmaThree
        }
    ];

    @Input()
    showDescription: boolean;

    @Input()
    hidden: boolean;
}
